import React, { Component } from 'react';
import { connect } from "react-redux";
import './Dashboard.css'
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import axios from "../../axios-cmk";
import { Button, Col, Container, Row } from "reactstrap";
import FontAwesome from "react-fontawesome";
import { Link, withRouter } from "react-router-dom";


class Dashboard extends Component {

    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <Button block={true} className="dashboardButton visits" onClick={()=>{this.props.history.push("/calendar")}}>
                            <FontAwesome name='calendar' className='action' />
                            Wizyty
                        </Button>
                    </Col>
                    <Col>
                        <Button block={true} className="dashboardButton reports" onClick={()=>{this.props.history.push("/reports")}}>
                            <FontAwesome name='table' className='action' />
                            Raporty
                        </Button>
                    </Col>
                </Row>
                {/*<Row>*/}
                {/*    <Col><Button block="true"><Link to="/patients">Topics</Link></Button></Col>*/}
                {/*</Row>*/}
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard, axios));


// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js